import React, { Fragment, useState } from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import { Message, Actions, StyledButton } from 'shared/modals/Styles';
import Box from '@mui/material/Box';

const propTypes = {
  project: PropTypes.object,
  modalClose: PropTypes.func.isRequired,
  updateIssue: PropTypes.func.isRequired,
  confirmMessage: PropTypes.string.isRequired,
};

const DashboardKanbanConfirmPopUpWindow = ({
  modalClose,
  updateIssue,
  confirmMessage,
}) => {
  const [isWorking] = useState(false);

  const handleYesButtonClick = () => {
    updateIssue();
    modalClose();
  };

  return (
    <Fragment>
      <Box
        sx={{
          padding: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Message>{confirmMessage}</Message>
        <Actions>
          <StyledButton
            data-testid="kanban-kenshin-confirm-window-button-yes"
            variant="primary"
            isWorking={isWorking}
            onClick={handleYesButtonClick}>
            {intl.get('kanban_confirm_popup_window_button_yes')}
          </StyledButton>
          <StyledButton
            data-testid="kanban-kenshin-confirm-window-button-no"
            hollow
            onClick={modalClose}>
            {intl.get('kanban_confirm_popup_window_button_no')}
          </StyledButton>
        </Actions>
      </Box>
    </Fragment>
  );
};
DashboardKanbanConfirmPopUpWindow.propTypes = propTypes;

export default DashboardKanbanConfirmPopUpWindow;
